<template>
    <div class="serial-form">
        <ol class="breadcrumb pull-right">
            <li>
                <router-link :to="{path: '/'}">Home</router-link>
            </li>
            <li>
                <router-link :to="{path: '/tryout-groups'}">Tryout Serial</router-link>
            </li>
            <li class="active">Create</li>
        </ol>
        <!-- begin page-header -->
        <h1 class="page-header">Buat Tryout Serial Baru</h1>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <h4 class="panel-title">Buat Tryout Serial</h4>
                    </div>
                    <div class="panel-body">
                        <form class="form-horizontal form-bordered">
                            <div class="form-group">
                                <label class="col-md-2 control-label">Nama *</label>
                                <div class="col-md-8 col-xs-12">
                                <input type="text" class="form-control" placeholder="Nama tryout serial" v-model="title">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Deskripsi</label>
                                <div class="col-md-8 col-xs-12">
                                <input type="text" class="form-control" placeholder="Deskripsi tryout serial" v-model="description">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label">Kelas</label>
                                <div class="col-md-8 col-xs-12">
                                    <select class="form-control" v-model="grade">
                                        <option v-for="n in 9" :value="n+3" v-bind:key="n">{{n+3}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group" v-if="id != null">
                                <label class="col-md-2 control-label">Serial</label>
                                <div class="col-md-8 col-xs-12">
                                    <app-tryoutgroupchooser 
                                        v-on:dblClicked="onGroupSelected($event)"
                                        :params="{grade: grade, attached: false}"></app-tryoutgroupchooser>
                                    <br />
                                    <div class="panel panel-inverse" v-for="group in groups" v-bind:key="group.series_sequence">
                                        <div class="panel-heading">
                                            <div class="btn-group pull-right">
                                                <button type="button" class="btn btn-xs btn-danger btn-icon btn-circle" @click="confirmUnAttachGroup(group)"><i class="fa fa-times"></i></button>
                                            </div>
                                            <h4 class="panel-title">group id: {{group.id}}</h4>
                                        </div>
                                        <div class="panel-body bg-silver-lighter m-b-5">
                                            <h4>
                                                <a class="btn btn-inverse btn-icon btn-circle text-white m-r-10">{{group.series_sequence}}</a>
                                                {{group.name}}
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <hr />
                        <div class="pull-right"><button type="button" class="btn btn-success" @click="save()">Simpan</button></div>
                    </div>
                </div>
            </div>
        </div>
        <app-spinner v-if="isLoading"></app-spinner>
        <app-modal v-if="showUnAttachModal" :withCancel="true" v-on:ok="processUnAttachGroup()" v-on:cancel="showUnAttachModal = false">
            <h4 slot="header">Hapus Tryout Group</h4>
            <div slot="body">Apakah anda yakin akan menghapus Tryout Group <strong class="text-danger">{{selectedGroup.name}}</strong>
            dari Serial <strong class="text-danger">{{title}}</strong> ?</div>
        </app-modal>
    </div>
</template>
<script>
import TryoutService from '@/services/tryout.js'
import TryoutGroupChooser from '@/components/tryout_group/TryoutGroupChooser'
import Spinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'

export default {
    name: 'serial-form',
    components: {
        'app-spinner': Spinner,
        'app-tryoutgroupchooser': TryoutGroupChooser,
        'app-modal': Modal
    },
    data: function () {
        return {
            id: null,
            title: null,
            description: null,
            grade: 12,
            isLoading: false,
            errors: [],
            groups: [],
            stack: [],
            showUnAttachModal: false,
            selectedGroup: null
        }
    },
    methods: {
        validateForm: function () {
            this.errors = []
            if (!this.title) this.errors.push('Judul harus diisi')

            return this.errors.length == 0
        },
        save: function () {
            var context = this
            this.isLoading = true
            if (this.validateForm()) {
                var data = {
                    title: this.title,
                    description: this.description,
                    grade: this.grade
                }

                TryoutService.createTryoutSeries(data, function (response) {
                    if (response.success) {
                        context.id = response.data.id
                        context.title = response.data.title
                        context.description = response.data.description
                        context.grade = response.data.grade
                        context.$router.push({ path: '/serial/form', query: { id: response.data.id } })
                    }

                    context.isLoading = false
                })
            } else {
                this.isLoading = false
            }
        },
        onGroupSelected: function (group) {
            this.getGroupDetail(group.id)
        },
        getGroupDetail: function (groupId) {
            this.isLoading = true
            var context = this

            TryoutService.getTryoutGroup(groupId, function (response) {
                if (response.success) {
                    context.stack.push(response.data)

                    if (response.data.dependency_id === null) context.processAttachGroups()
                    else context.getGroupDetail(response.data.dependency_id)
                }

                context.isLoading = false
            })
        },
        processAttachGroups: function () {
            if (this.stack.length == 0) {
                this.getListOfAttachedGroups()
            } else {
                this.isLoading = true

                var context = this
                var group = this.stack.pop()
                TryoutService.attachGroupIntoSeries(group.id, this.id, function (response) {
                    if (response.success) {
                        context.isLoading = false
                        context.processAttachGroups()
                    } else {
                        this.isLoading = false
                    }
                })
            }
        },
        confirmUnAttachGroup: function (group) {
            this.selectedGroup = group
            this.showUnAttachModal = true
        },
        processUnAttachGroup: function () {
            var found = this.groups.find(g => g.dependency_id === this.selectedGroup.id)
            if (found) {
                var message = 'Tidak dapat menghapus group dikarenakan menjadi prasyarat: ' + found.name
                this.$store.commit('error_show', message)
                this.showUnAttachModal = false
            }
            else {
                var context = this
                var groupId = this.selectedGroup.id
                var seriesId = this.id

                this.isLoading = true
                TryoutService.dettachGroupFromSeries(groupId, seriesId, function (response) {
                    if (response.success) {
                        context.groups = []
                        var params = { series_id: context.id }
                        TryoutService.getListOfTryoutGroups(null, null, params, function (response) {
                            if (response.success) {
                                response.data.forEach(function (group) {
                                    context.groups.push(group)
                                })

                                context.groups.sort(function (a, b) {
                                    return a.series_sequence - b.series_sequence
                                })
                            }

                            context.isLoading = false
                            context.showUnAttachModal = false
                        }, context.grade, context.id)
                    }
                })
            }
        },
        getListOfAttachedGroups: function () {
            var context = this
            var params = { series_id: this.id }
            TryoutService.getListOfTryoutGroups(null, null, params, function (response) {
                if (response.success) {
                    context.groups = []
                    response.data.forEach(function (group) {
                        context.groups.push(group)
                    })

                    context.groups.sort(function (a, b) {
                        return a.series_sequence - b.series_sequence
                    })
                }
            }, context.grade, context.id)
        }
    },
    mounted: function () {
        var context = this
        var seriesId = this.$route.query.id
        if (this.$route.query.id) {
            this.isLoading = true
            TryoutService.getTryoutSeries(seriesId, function (response) {
                if (response.success) {
                    context.id = response.data.id
                    context.title = response.data.title
                    context.description = response.data.description
                    context.grade = response.data.grade
                    context.getListOfAttachedGroups()
                }

                context.isLoading = false
            })
        } else {
            this.isLoading = false
        }
    }
}
</script>


// WEBPACK FOOTER //
// Form.vue?6e427683